"use client";

import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const teamMembers = [{
  name: "Sarah Jenkins",
  role: "Chief Strategy Officer",
  bio: "Sarah brings over 15 years of strategic leadership, guiding our vision with a focus on sustainable growth and innovation.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/team_sarah_jenkins.png",
  initials: "SJ"
}, {
  name: "David Chen",
  role: "Lead Product Designer",
  bio: "With a keen eye for minimalism and user-centric design, David ensures every interaction is intuitive and visually compelling.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/team_david_chen.png",
  initials: "DC"
}, {
  name: "Michael Ross",
  role: "Senior Developer",
  bio: "Michael architects robust, scalable solutions, turning complex technical challenges into seamless digital experiences.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/team_michael_ross.png",
  initials: "MR"
}];
export default function Team() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}